import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ReportService from "services/reportService";

const initialState = {
  loading: false,
  error: null,
  reports: [],
  currentReport: null,
};

export const getAllReportsParents = createAsyncThunk(
  "reports/getAllmParents",
  async (_, thunkAPI) => {
    try {
      const response = await ReportService.getAllParentsReports();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data.data.message);
    }
  }
);

export const getAllReportsBabysitter = createAsyncThunk(
  "reports/getAllBabysitter",
  async (id, thunkAPI) => {
    try {
      const response = await ReportService.getAllBabysittersReports(id);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data.data.message);
    }
  }
);

export const getReportParent = createAsyncThunk(
  "reports/Parent",
  async (reportId, thunkAPI) => {
    try {
      const response = await ReportService.getOneReportParent(reportId);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data.data.message);
    }
  }
);

export const getReportBabysitter = createAsyncThunk(
  "reports/Babysitter",
  async (reportId, thunkAPI) => {
    try {
      const response = await ReportService.getOneReportBabysitter(reportId);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data.data.message);
    }
  }
);

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllReportsParents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllReportsParents.fulfilled, (state, action) => {
        state.loading = false;
        state.reports = action.payload;
      })
      .addCase(getAllReportsParents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllReportsBabysitter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllReportsBabysitter.fulfilled, (state, action) => {
        state.loading = false;
        state.reports = action.payload;
      })
      .addCase(getAllReportsBabysitter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getReportParent.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.currentReport = null;
      })
      .addCase(getReportParent.fulfilled, (state, action) => {
        state.loading = false;
        state.currentReport = action.payload;
      })
      .addCase(getReportParent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.currentReport = null;
      })
      .addCase(getReportBabysitter.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.currentReport = null;
      })
      .addCase(getReportBabysitter.fulfilled, (state, action) => {
        state.loading = false;
        state.currentReport = action.payload;
      })
      .addCase(getReportBabysitter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.currentReport = null;
      });
  },
});

export default reportsSlice.reducer;
